import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _styled from "styled-components";
var _div;
import { useRef, useState } from 'react';
import cn from 'classnames';
import { css } from 'styled-components';
import Flash from '@crehana/compass.icons.outline/Flash';
import CC from '@crehana/icons/CC';
import ClassNote from '@crehana/icons/ClassNote';
import Forward10 from '@crehana/icons/Forward10';
import Fullscreen from '@crehana/icons/Fullscreen';
import FullscreenOff from '@crehana/icons/FullscreenOff';
import PIPOff from '@crehana/icons/outline/PIPOff';
import PIPOn from '@crehana/icons/outline/PIPOn';
import Plus from '@crehana/icons/outline/Plus';
import VolumeOff from '@crehana/icons/outline/VolumeOff';
import VolumeUp from '@crehana/icons/outline/VolumeUp';
import Pause from '@crehana/icons/Pause';
import PlayArrow from '@crehana/icons/PlayArrow';
import Replay10 from '@crehana/icons/Replay10';
import { colors, Tooltip } from '@crehana/ui';
import { date } from '@crehana/utils';
import { KEY_NAME_BY_ACTION } from "../../constants";
import { useFullscreenContext } from "../../context/Fullscreen";
import { useHlsContext } from "../../context/Hls";
import { usePictureInPictureContext } from "../../context/PictureInPicture";
import { usePlaybackContext } from "../../context/Playback";
import { useResponsiveContext } from "../../context/Responsive";
import { useSubtitleContext } from "../../context/Subtitle";
import { useUIContext } from "../../context/UI";
import { useVolumeContext } from "../../context/Volume";
import { useTranslation } from "../../hooks";
import PlayerBlockedModal from "../player-blocked-modal";
import { ControlButton, SettingsButton } from "../ui";
import NoteAI from "./NoteAi/NoteAI";
import ProgressBar from "./ProgressBar";
import VolumeBar from "./VolumeBar";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var toTimestamp = date.toTimestamp;
var BottomControls = function BottomControls() {
  var _useResponsiveContext = useResponsiveContext(),
    playerSize = _useResponsiveContext.playerSize;
  var refPopper = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpenPopper = _useState2[0],
    setIsOpenPopper = _useState2[1];
  var isSm = playerSize.value === 'sm';
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpenBlockedModal = _useState4[0],
    setIsOpenBlockedModal = _useState4[1];
  var _useFullscreenContext = useFullscreenContext(),
    fullscreenIsAvailable = _useFullscreenContext.fullscreenIsAvailable,
    isFullscreen = _useFullscreenContext.isFullscreen,
    toggleFullscreen = _useFullscreenContext.toggleFullscreen;
  var _usePictureInPictureC = usePictureInPictureContext(),
    pictureInPictureIsAvailable = _usePictureInPictureC.pictureInPictureIsAvailable,
    pictureInPictureIsActive = _usePictureInPictureC.pictureInPictureIsActive,
    togglePictureInPicture = _usePictureInPictureC.togglePictureInPicture;
  var _usePlaybackContext = usePlaybackContext(),
    duration = _usePlaybackContext.duration,
    currentProgress = _usePlaybackContext.currentProgress,
    currentTime = _usePlaybackContext.currentTime,
    bufferedRanges = _usePlaybackContext.bufferedRanges,
    seek = _usePlaybackContext.seek,
    onSeek = _usePlaybackContext.onSeek,
    isPlaying = _usePlaybackContext.isPlaying,
    togglePlay = _usePlaybackContext.togglePlay,
    onBackward = _usePlaybackContext.onBackward,
    onForward = _usePlaybackContext.onForward,
    disableSeekForward = _usePlaybackContext.disableSeekForward;
  var _useHlsContext = useHlsContext(),
    currentQualityLabel = _useHlsContext.currentQualityLabel,
    hasLowQuality = _useHlsContext.hasLowQuality,
    qualities = _useHlsContext.qualities,
    audios = _useHlsContext.audios;
  var _useSubtitleContext = useSubtitleContext(),
    subtitleOptions = _useSubtitleContext.subtitleOptions,
    currentSubtitleLang = _useSubtitleContext.currentSubtitleLang;
  var _useVolumeContext = useVolumeContext(),
    volume = _useVolumeContext.volume,
    changeVolume = _useVolumeContext.changeVolume,
    muted = _useVolumeContext.muted,
    toggleMute = _useVolumeContext.toggleMute;
  var _useUIContext = useUIContext(),
    activeMenu = _useUIContext.activeMenu,
    changeActiveMenu = _useUIContext.changeActiveMenu,
    hideActiveMenu = _useUIContext.hideActiveMenu,
    onAddNote = _useUIContext.onAddNote,
    classNotes = _useUIContext.classNotes,
    hideSpeedOptions = _useUIContext.hideSpeedOptions,
    hideSkipButtons = _useUIContext.hideSkipButtons,
    visibleUi = _useUIContext.visibleUi,
    getOpenedAI = _useUIContext.getOpenedAI,
    toggleOpenedAI = _useUIContext.putOpenedAI,
    visibleAI = _useUIContext.visibleAI;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var hasSettings = !!qualities || !hideSpeedOptions;
  var isFirstOpenedAI = getOpenedAI();
  var hasSubtitleOrAudioOptions = !!(subtitleOptions !== null && subtitleOptions !== void 0 && subtitleOptions.length) || !!(audios !== null && audios !== void 0 && audios.length);
  var hasActiveSubtitles = (currentSubtitleLang === null || currentSubtitleLang === void 0 ? void 0 : currentSubtitleLang.value) !== 'none';
  var toggleMenu = function toggleMenu(menu) {
    if (activeMenu === menu) {
      hideActiveMenu();
    } else {
      changeActiveMenu(menu);
    }
  };
  var hiddePopperAi = function hiddePopperAi() {
    setIsOpenPopper(false);
    toggleOpenedAI();
  };
  var onTogglePlay = function onTogglePlay() {
    var button = document.querySelector('.cp-toggle-play');
    togglePlay();
    if (button) {
      button.blur();
    }
  };
  var paddingCss = /*#__PURE__*/css(["\n    padding: 0 8px 8px 8px;\n  "]);
  if (playerSize.matches.xs) {
    paddingCss = css(["\n      padding: 0 16px 20px 16px;\n    "]);
  }
  if (playerSize.matches.sm) {
    paddingCss = css(["\n      padding: 0 20px 24px 20px;\n    "]);
  }
  if (playerSize.matches.md) {
    paddingCss = css(["\n      padding: 0 24px 12px 24px;\n    "]);
  }
  var togglePlayLabel = t(isPlaying ? 'PAUSE_LABEL' : 'PLAY_LABEL');
  var VolumeIcon = muted ? VolumeOff : VolumeUp;
  var volumeLabel = t(muted ? 'UNMUTE_LABEL' : 'MUTE_LABEL');
  var PIPIcon = pictureInPictureIsActive ? PIPOff : PIPOn;
  var pipLabel = t(pictureInPictureIsActive ? 'DISABLE_PIP_LABEL' : 'PIP_LABEL');
  var FullscreenIcon = isFullscreen ? FullscreenOff : Fullscreen;
  var fullscreenLabel = t(isFullscreen ? 'FULLSCREEN_DISABLE_LABEL' : 'FULLSCREEN_LABEL');
  var fullscreenTooltip = "".concat(fullscreenLabel, " (").concat(t(KEY_NAME_BY_ACTION.TOGGLE_FULLSCREEN), ")");
  if (!fullscreenIsAvailable) {
    fullscreenLabel = t('FULLSCREEN_NOT_AVAILABLE');
    fullscreenTooltip = t('FULLSCREEN_NOT_AVAILABLE');
  }
  return /*#__PURE__*/_jsxs(_StyledDiv, {
    className: cn('cp-bottom-controls absolute w-full flex flex-col justify-end bottom-0 right-0 left-0', visibleUi ? 'opacity-1 z-6' : 'opacity-0 z-3'),
    $_css: paddingCss,
    children: [!playerSize.matches.md && /*#__PURE__*/_jsxs("div", {
      className: cn('flex w-full items-end justify-between', playerSize.matches.sm ? 'mb-8' : 'mb-4'),
      children: [/*#__PURE__*/_jsx("span", {
        className: "font-label text-white",
        children: "".concat(toTimestamp(currentTime), " / ").concat(toTimestamp(duration))
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex items-end",
        children: [hasSettings && playerSize.matches.sm && /*#__PURE__*/_jsx(SettingsButton, {
          className: "cp-settings-btn-tablet ml-8",
          onClick: function onClick() {
            return toggleMenu('settings');
          },
          currentQuality: currentQualityLabel,
          hasLowQuality: hasLowQuality,
          isInBottomControls: true
        }), hasSubtitleOrAudioOptions && /*#__PURE__*/_jsx(ControlButton, {
          className: "cp-cc-btn-tablet ml-24",
          icon: {
            component: CC
          },
          onClick: function onClick() {
            return toggleMenu('cc');
          },
          isActive: hasActiveSubtitles,
          "aria-label": t('CC_LABEL'),
          isSm: isSm
        }), playerSize.matches.sm ? /*#__PURE__*/_jsx(VolumeBar, {
          className: "ml-24",
          volume: volume,
          changeVolume: changeVolume,
          muted: muted,
          toggleMute: toggleMute,
          visibleUi: visibleUi,
          buttonLabel: volumeLabel,
          tooltipLabel: "".concat(volumeLabel, " (").concat(t(KEY_NAME_BY_ACTION.TOGGLE_MUTE), ")"),
          isSm: isSm,
          vertical: true
        }) : /*#__PURE__*/_jsx(ControlButton, {
          className: "ml-24",
          icon: {
            component: VolumeIcon
          },
          onClick: toggleMute,
          "aria-label": volumeLabel,
          isSm: isSm
        }), playerSize.matches.sm && pictureInPictureIsAvailable && /*#__PURE__*/_jsx(ControlButton, {
          className: "ml-24",
          icon: {
            component: PIPIcon
          },
          onClick: togglePictureInPicture,
          "aria-label": pipLabel,
          isSm: isSm
        }), /*#__PURE__*/_jsx(ControlButton, {
          className: "ml-24",
          icon: {
            component: FullscreenIcon
          },
          onClick: toggleFullscreen,
          "aria-label": fullscreenLabel,
          isSm: isSm,
          disabled: !fullscreenIsAvailable
        })]
      })]
    }), /*#__PURE__*/_jsx(ProgressBar, {
      seek: seek,
      duration: duration,
      currentTime: currentTime,
      currentProgress: currentProgress,
      bufferedRanges: bufferedRanges,
      classNotes: classNotes,
      onSeek: onSeek,
      playerSize: playerSize,
      visibleUi: visibleUi,
      disableSeekForward: disableSeekForward,
      onBlockedProgressChange: function onBlockedProgressChange() {
        return setIsOpenBlockedModal(true);
      }
    }), playerSize.matches.md && /*#__PURE__*/_jsxs("div", {
      className: "flex w-full items-center justify-between py-12 px-16",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex items-center justify-between",
        children: [!hideSkipButtons && /*#__PURE__*/_jsx(Tooltip, {
          label: t('BACKWARD_LABEL'),
          position: "top",
          isDark: true,
          children: /*#__PURE__*/_jsx("div", {
            className: "flex items-center mr-32",
            children: /*#__PURE__*/_jsx(ControlButton, {
              icon: {
                component: Replay10
              },
              onClick: onBackward,
              disabled: currentTime === 0,
              "aria-label": t('BACKWARD_LABEL'),
              isSm: isSm
            })
          })
        }), /*#__PURE__*/_jsx(Tooltip, {
          label: "".concat(togglePlayLabel, " (").concat(t(KEY_NAME_BY_ACTION.TOGGLE_PLAY), ")"),
          position: "top",
          isDark: true,
          children: /*#__PURE__*/_jsx("div", {
            className: "flex items-center mr-32",
            children: /*#__PURE__*/_jsx(ControlButton, {
              className: "cp-toggle-play",
              icon: {
                component: isPlaying ? Pause : PlayArrow
              },
              onClick: onTogglePlay,
              "aria-label": togglePlayLabel,
              isSm: isSm
            })
          })
        }), !hideSkipButtons && /*#__PURE__*/_jsx(Tooltip, {
          label: t('FORWARD_LABEL'),
          position: "top",
          isDark: true,
          children: /*#__PURE__*/_jsx("div", {
            className: "flex items-center mr-32",
            children: /*#__PURE__*/_jsx(ControlButton, {
              icon: {
                component: Forward10
              },
              onClick: onForward,
              disabled: disableSeekForward || currentTime > duration - 3,
              "aria-label": t('FORWARD_LABEL'),
              isSm: isSm
            })
          })
        }), /*#__PURE__*/_jsx("span", {
          className: "font-label text-white mr-32 pt-4",
          children: "".concat(toTimestamp(currentTime), " / ").concat(toTimestamp(duration))
        }), /*#__PURE__*/_jsx(VolumeBar, {
          volume: volume,
          changeVolume: changeVolume,
          muted: muted,
          toggleMute: toggleMute,
          visibleUi: visibleUi,
          buttonLabel: volumeLabel,
          tooltipLabel: "".concat(volumeLabel, " (").concat(t(KEY_NAME_BY_ACTION.TOGGLE_MUTE), ")"),
          isSm: isSm
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex items-center justify-between",
        children: [visibleAI && /*#__PURE__*/_jsx(Tooltip, {
          label: t('AI_LABEL'),
          position: "top",
          isDark: true,
          children: /*#__PURE__*/_jsxs("div", {
            className: "flex items-center ml-32 relative",
            children: [!isFirstOpenedAI && (_div || (_div = /*#__PURE__*/_jsx("div", {
              className: "h-8 mr-4 rounded-full bg-secondary-light w-8"
            }))), /*#__PURE__*/_jsx(ControlButton, {
              icon: {
                component: Flash
              },
              onClick: function onClick() {
                return setIsOpenPopper(true);
              },
              "aria-label": t('AI_LABEL'),
              isSm: isSm,
              ref: refPopper
            }), /*#__PURE__*/_jsx(NoteAI, {
              ref: refPopper,
              isOpenPopper: isOpenPopper,
              hiddePopperAi: hiddePopperAi,
              isLg: playerSize.value === 'lg'
            })]
          })
        }), onAddNote && /*#__PURE__*/_jsx(Tooltip, {
          label: "".concat(t('ADD_NOTE_LABEL'), " (").concat(t(KEY_NAME_BY_ACTION.ADD_NOTE), ")"),
          position: "top",
          isDark: true,
          children: /*#__PURE__*/_jsxs("button", {
            type: "button",
            className: "bg-transparent focus:outline-none flex items-center ml-32 ".concat(visibleUi ? 'cursor-pointer' : 'cursor-none'),
            onClick: onAddNote,
            "aria-label": t('ADD_NOTE_LABEL'),
            children: [/*#__PURE__*/_jsx(Plus, {
              size: 16,
              color: colors.white
            }), /*#__PURE__*/_jsx(ClassNote, {
              size: 24,
              color: colors.white
            })]
          })
        }), hasSubtitleOrAudioOptions && /*#__PURE__*/_jsx(Tooltip, {
          label: t('CC_LABEL'),
          position: "top",
          isDark: true,
          children: /*#__PURE__*/_jsx("div", {
            className: "cp-cc-btn flex items-center relative ml-32",
            children: /*#__PURE__*/_jsx(ControlButton, {
              icon: {
                component: CC
              },
              onClick: function onClick() {
                return toggleMenu('cc');
              },
              isActive: hasActiveSubtitles || activeMenu === 'cc',
              "aria-label": t('CC_LABEL'),
              isSm: isSm
            })
          })
        }), hasSettings && /*#__PURE__*/_jsx(Tooltip, {
          label: t('SETTINGS_LABEL'),
          position: "top",
          isDark: true,
          children: /*#__PURE__*/_jsx("div", {
            className: "cp-settings-btn flex items-center relative ml-32",
            children: /*#__PURE__*/_jsx(SettingsButton, {
              onClick: function onClick() {
                return toggleMenu('settings');
              },
              currentQuality: currentQualityLabel,
              hasLowQuality: hasLowQuality,
              isInBottomControls: true
            })
          })
        }), pictureInPictureIsAvailable && /*#__PURE__*/_jsx(Tooltip, {
          label: pipLabel,
          position: "top",
          isDark: true,
          children: /*#__PURE__*/_jsx("div", {
            className: "flex items-center relative ml-32",
            children: /*#__PURE__*/_jsx(ControlButton, {
              icon: {
                component: PIPIcon
              },
              onClick: togglePictureInPicture,
              "aria-label": pipLabel,
              isSm: isSm
            })
          })
        }), /*#__PURE__*/_jsx(Tooltip, {
          label: fullscreenTooltip,
          position: "left",
          isDark: true,
          children: /*#__PURE__*/_jsx("div", {
            className: "flex items-center relative ml-32",
            children: /*#__PURE__*/_jsx(ControlButton, {
              icon: {
                component: FullscreenIcon
              },
              onClick: toggleFullscreen,
              "aria-label": fullscreenLabel,
              isSm: isSm,
              disabled: !fullscreenIsAvailable
            })
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(PlayerBlockedModal, {
      isOpen: isOpenBlockedModal,
      onClose: function onClose() {
        return setIsOpenBlockedModal(false);
      },
      onConfirm: function onConfirm() {
        return setIsOpenBlockedModal(false);
      }
    })]
  });
};
export default BottomControls;
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-1en22ml-0"
})(["\n        ", "\n        transition: ", ";\n        & span {\n          user-select: none;\n        }\n      "], function (p) {
  return p.$_css;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.transition('opacity', 300);
});